import { Link } from 'react-router-dom';
import { routes } from '../../config/links';
import styles from './RequestDemoButton.module.css';

interface RequestDemoButtonProps {
  size?: 'md' | 'lg';
  className?: string;
  variant?: 'primary' | 'inline';
}

function RequestDemoButton({ size = 'md', className = '', variant = 'primary' }: RequestDemoButtonProps) {
  const classes = [styles.button, styles[size], styles[variant], className].filter(Boolean).join(' ');

  return (
    <Link to={routes.requestDemo} className={classes}>
      Request Demo
    </Link>
  );
}

export default RequestDemoButton;
